import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ScheduleModule } from '@nestjs/schedule';
import { MainDashboardController } from './main-dashboard.controller';
import { MainDashboardService } from './main-dashboard.service';


@Module({
  imports: [
    TypeOrmModule.forFeature([]),
    ScheduleModule.forRoot(),

  ],
  controllers: [MainDashboardController],
  providers: [MainDashboardService, ApplicationExceptionHandler]
})
export class MainDashboardModule {}
